import { apiGet, apiPost, apiPut, apiDelete } from "../../api/client";
import { IDriver } from "../../types";

/**
 * REST client for the `drivers` resource. Replaces direct Firestore access so
 * driver data is read and written exclusively through the API.
 */

const DRIVERS_PATH = "/api/drivers/";

/** Serialized driver payload sent as a JSON request body (e.g. `Driver.data()`). */
type DriverPayload = Record<string, unknown>;

/** Full driver list for a workspace (no pagination — current default). */
export const listDrivers = async (
  token: string,
  workspaceId: string,
): Promise<IDriver[]> => {
  const envelope = await apiGet(token, DRIVERS_PATH, workspaceId);
  return (envelope?.data as IDriver[]) ?? [];
};

export const createDriver = async (
  token: string,
  workspaceId: string,
  driver: DriverPayload,
): Promise<IDriver> => {
  const envelope = await apiPost(token, DRIVERS_PATH, driver, workspaceId);
  return envelope?.data as IDriver;
};

export const updateDriver = async (
  token: string,
  workspaceId: string,
  driverId: string,
  driver: DriverPayload,
): Promise<IDriver> => {
  const envelope = await apiPut(
    token,
    `${DRIVERS_PATH}${driverId}`,
    driver,
    workspaceId,
  );
  return envelope?.data as IDriver;
};

export const deleteDriver = async (
  token: string,
  workspaceId: string,
  driverId: string,
): Promise<void> => {
  await apiDelete(token, `${DRIVERS_PATH}${driverId}`, workspaceId);
};
